const BotTrigger = () => import('@root/src/views/GCB2/BotTrigger.vue')
const TaggingServices = () => import('@root/src/views/GCB2/TaggingServices.vue')
const GCB2StartPage = () => import('@/views/GCB2/StartPage.vue')
const Activation = () => import('@/views/GCB2/Activation.vue')
const MassActivationEdit = () => import('@/views/GCB2/MassActivationEdit.vue')
const KpiSchemeSetting = () => import('@/views/GCB2/KpiSchemeSetting.vue')
const ClientNotifications = () => import('@/views/ClientNotifications.vue')
const Callbot = () => import('@/views/Callbot/Callbot.vue')
const BusinessPulseReport = () => import('@/views/GCB2/BusinessPulseReport.vue')

import doctorReportRoutes from '@/modules/DoctorReport/routes'
import doctorReportLorealRoutes from '@/modules/DoctorReportLoreal/routes'
import { AvgCheckReportModule } from '@root/src/modules/AvgCheckReport/AvgCheckReport.module'
import { HotWindowsModule } from '@root/src/modules/HotWindows/HotWindows.module'
export default [
    {
        path: '/project/:id/callbot',
        name: 'Callbot',
        component: Callbot,
        // Флаг callbotWidget проверяется на странице: без него показывается экран покупки.
    },
    {
        path: '/project/:id/GCB2',
        name: 'GCB2Main',
        props: { dashboardType: 'main' },
        component: GCB2StartPage,
    },
    {
        path: '/project/:id/GCB2/businessPulseReport',
        name: 'GCB2BusinessPulseReport',
        component: BusinessPulseReport,
        requiredRoles: ['gcb2:analytics:view'],
        // Тумблер покупки маршрут не закрывает: без него страница показывает экран подключения.
        // Флаг оставлен, чтобы отключённый коннектор GCB2 по-прежнему уводил на проект.
        requiresBusinessPulseReport: true,
        // Отчёт 2.0 считается по данным YCLIENTS — на других CRM недоступен
        requiresYClients: true,
    },
    {
        path: '/project/:id/GCB2/returnability',
        name: 'GCB2Returnability',
        props: { dashboardType: 'returnability' },
        component: GCB2StartPage,
    },
    {
        path: '/project/:id/GCB2/marketingReport',
        name: 'GCB2MarketingReport',
        props: { dashboardType: 'marketingReport' },
        component: GCB2StartPage,
    },
    {
        path: '/project/:id/GCB2/subscribersGrowth',
        name: 'GCB2SubscribersGrowth',
        props: { dashboardType: 'subscribersGrowth' },
        component: GCB2StartPage,
        requiredRoles: ['gcb2:subscribersGrowth:view'],
    },
    {
        path: '/project/:id/GCB2/simpleReports/',
        name: 'GCB2SimpleReports',
        props: { dashboardType: 'simpleReports' },
        component: GCB2StartPage,
    },
    {
        path: '/project/:id/GCB2/whereIsMyClients/',
        name: 'GCB2WhereIsMyClients',
        props: { dashboardType: 'whereIsMyClients' },
        component: GCB2StartPage,
    },
    {
        path: '/project/:id/GCB2/kpi/',
        name: 'GCB2SimpleReports',
        props: { dashboardType: 'kpi' },
        component: GCB2StartPage,
    },
    {
        path: '/project/:id/GCB2/churn',
        name: 'GCB2ChurnReport',
        props: { dashboardType: 'churn' },
        requiredRoles: ['gcb2:churnReport:view'],
        component: GCB2StartPage,
    },
    {
        path: '/project/:id/GCB2/staff',
        name: 'GCB2StaffReport',
        props: { dashboardType: 'staff' },
        component: GCB2StartPage,
        requiredRoles: ['gcb2:staffReport:view'],
    },
    {
        path: '/project/:id/GCB2/sameDayRec',
        name: 'GCB2SameDayRecReport',
        props: { dashboardType: 'sameDayRec' },
        component: GCB2StartPage,
        // Право gcb2:sameDayRec:view проверяется на странице отчёта.
    },
    {
        path: '/project/:id/GCB2/fourhandsReport',
        name: 'GCB2KpiSchemeSetting',
        props: { dashboardType: 'fourhandsReport' },
        component: GCB2StartPage,
    },

    {
        path: '/project/:id/GCB2/personaReport',
        name: 'GCB2KpiSchemeSetting',
        props: { dashboardType: 'personaReport' },
        component: GCB2StartPage,
    },

    {
        path: '/project/:id/GCB2/kpi/setting',
        name: 'GCB2KpiSchemeSetting',
        component: KpiSchemeSetting,
    },

    {
        path: '/project/:id/GCB2/Activation',
        name: 'GCB2Activation',
        component: Activation,
    },
    {
        path: '/project/:id/GCB2/ActivationsEdit',
        name: 'GCB2ActivationsEdit',
        component: MassActivationEdit,
    },
    {
        path: '/project/:id/GCB2/botTrigger',
        name: 'GCB2BotTrigger',
        component: BotTrigger,
    },
    {
        path: '/project/:id/GCB2/taggingServices',
        name: 'GCB2TaggingServices',
        component: TaggingServices,
    },
    {
        path: '/project/:id/clientNotifications',
        name: 'ClientNotifications',
        component: ClientNotifications,
    },
    {
        path: '/project/:id/clientNotifications/botTrigger',
        name: 'ClientNotificationsBotTrigger',
        component: BotTrigger,
    },
]
    .concat(doctorReportRoutes)
    .concat(doctorReportLorealRoutes)
    .concat(AvgCheckReportModule.routes)
    .concat(HotWindowsModule.routes)
